import {
  SET_LINEALCHANNEL_HAS_AN_ERROR,
  SET_LINEALCHANNEL_SUCCESS,
} from 'reducers/linealChannel/constants';

const setLinealChannelDataSuccess = payload => ({
  type: SET_LINEALCHANNEL_SUCCESS,
  payload,
});

const setLinealChannelData = data => dispatch => {
  const { response, error, hasError } = data || {};
  const { paq } = response?.paqs || {};
  if (hasError) {
    return dispatch({
      type: SET_LINEALCHANNEL_HAS_AN_ERROR,
      error,
    });
  }
  const paqsCanPlay = paq?.filter(p => +p?.play === 1);
  const payload = {};
  paq
    ?.reduce((acc, curr) => [...acc, ...curr.groups.split(',')], [])
    ?.forEach(groupId => {
      const liveData = paqsCanPlay.filter(p =>
        p.groups.split(',').includes(groupId),
      );
      const timeshiftData = paq
        .filter(
          p => p.groups.split(',').includes(groupId) && +p.timeshift !== 0,
        )
        .reduce((acc, curr) => {
          if (+curr?.timeshift >= (+acc?.timeshift || 0)) {
            return curr;
          }
          return acc;
        }, null);
      const npvrData = paq
        .filter(
          p => p.groups.split(',').includes(groupId) && +p.npvrstorage !== 0,
        )
        .reduce((acc, curr) => {
          if (+curr?.npvrstorage >= (+acc?.npvrstorage || 0)) {
            return curr;
          }
          return acc;
        }, null);
      payload[groupId] = {
        live: {
          token: liveData[liveData.length - 1]?.payway_token || null,
          canPlay: liveData.length > 0 ? 1 : 0,
        },
        timeshift: {
          token: timeshiftData?.payway_token || null,
          value: timeshiftData?.timeshift || null,
        },
        npvr: {
          token: npvrData?.payway_token || null,
          value: npvrData?.npvrstorage || null,
        },
      };
    });
  dispatch(setLinealChannelDataSuccess(payload));
};

export { setLinealChannelData };
